// extracted by mini-css-extract-plugin
export default {"cls1":"buttonStyles-cls1_BWB","cls2":"buttonStyles-cls2_N11 buttonStyles-cls1_BWB"};